/**
 *
 * @module logLevel
 *
 */

/**
 *
 * @typedef {Number} LogLevel
 * @enum
 *
 * @desc The enumerable keys of LogLevel are strings like none, trace, warn, error, the values of which are integers.
 * The use of integers instead of strings for this enumeration allow comparison filters and ordering of severity.
 * There are non-enumerable numeric keys pointing back to the level name, see below:
 *
 * LogLevel[0] === 'none'; // hidden in prototype
 * LogLevel.none === 0; // own property
 *
 */

const LogLevel = (function () {

    const numericCodes = {
        0: 'none',
        1: 'trace',
        2: 'debug',
        3: 'info',
        4: 'warn',
        5: 'error'
    };

    /**
     *
     * @function {_LogLevel}
     *
     */
    function _LogLevel() {

        /**
         *
         * @type {LogLevel}
         * @desc A level that is ignored by the Logger.
         *
         */
        this.none = 0;

        /**
         *
         * @type {LogLevel}
         * @desc The level used for very detailed trace debugging.
         *
         */
        this.trace = 1;

        /**
         *
         * @type {LogLevel}
         * @desc The level used for normal debug events. This is the level for messages logged by the Logger.
         *
         */
        this.debug = 2;

        /**
         *
         * @type {LogLevel}
         * @desc The level used for informational events. This is the default base level in production.
         *
         */
        this.info = 3;

        /**
         *
         * @type {LogLevel}
         * @desc The level used for non-fatal errors or unusual events.
         *
         */
        this.warn = 4;

        /**
         *
         * @type {LogLevel}
         * @desc The level used for fatal events.
         *
         */
        this.error = 5;

    }

    _LogLevel.prototype = Object.create(numericCodes);

    /**
     *
     * @type {Object}
     *
     * @property {LogLevel} none
     * @property {LogLevel} trace
     * @property {LogLevel} debug
     * @property {LogLevel} info
     * @property {LogLevel} warn
     * @property {LogLevel} error
     *
     */
    return new _LogLevel();

}());

export default LogLevel;



// WEBPACK FOOTER //
// ./src/logging/logLevel.js